import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_LetterRequestCustomer_Review, LetterRequestCustomer_Review } from 'src/app/Interface/LetterRequestCustomer_Review';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterrequestcustomerEvaluateService } from 'src/app/Service/Letter/LetterrequestcustomerEvaluate.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-LetterRequestCustomerReviewFormList',
  templateUrl: './LetterRequestCustomerReviewFormList.component.html',
  styleUrls: ['./LetterRequestCustomerReviewFormList.component.scss']
})
export class LetterRequestCustomerReviewFormListComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private LetterrequestcustomerEvaluate_Service:LetterrequestcustomerEvaluateService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Evaluate:Array<LetterRequestCustomer_Review>=[]
  Data_Seleted_Delete:LetterRequestCustomer_Review=Empty_LetterRequestCustomer_Review()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(2172).subscribe(
      data=>{
        this.ReadData_Evaluate()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Evaluate(){
    this.Procssing=true
    this.LetterrequestcustomerEvaluate_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Evaluate=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:LetterRequestCustomer_Review){
    this.Procssing=true
    this.modalRef_Delete.hide()
    this.LetterrequestcustomerEvaluate_Service.Delete(item.id).subscribe(
      data => {
        this.Procssing = false
        if (data['id'] == -1)
          this.Alertify_Service.SuccessMessage("امکان فعال سازی بیش از 10 سوال وجود ندارد.")
        else if(item.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData_Evaluate()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  Switcher_Form: string = 'List'
  Set_Add_Switcher_Form() {
    this.Data_Seleted_Delete = Empty_LetterRequestCustomer_Review()
    this.Switcher_Form='Form'
  }

  Set_Edit_Switcher_Form(item:LetterRequestCustomer_Review) {
    this.Data_Seleted_Delete = item
    this.Switcher_Form='Form'
  }

  Set_Back_Switcher_Form() {
    this.Data_Seleted_Delete = Empty_LetterRequestCustomer_Review()
    this.Switcher_Form='List'
  }

}
